import { render } from "./quote2.vue?vue&type=template&id=0bda7044&scoped=true"
import script from "./quote2.vue?vue&type=script&lang=js"
export * from "./quote2.vue?vue&type=script&lang=js"

import "./quote2.vue?vue&type=style&index=0&id=0bda7044&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bda7044"]])

export default __exports__